import { NormalButton, PrimaryButton } from "components/buttons";

import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import line_228 from "assets/images/line_228.svg";
// import { promotionsContent } from "constants/promotions";
import parse from "html-react-parser";
import "./../sections.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import moment from "moment";

function Promotions() {
  const navigate = useNavigate();
  const [currentSlide, setSlide] = useState(0);
  const [promotionsContent, setPromotionsContent] = useState([]);

  const [isAlert, setIsAlert] = useState(false);
  const [externalLink, setExternalLink] = useState();

  const fetchPromotionsFromCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/promotion-and-campaigns?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await axios.get(
          "https://www.alrajhibank.com.my/assets/json/promotions.json",
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const cmsPromotions = await fetchPromotionsFromCMS();
        const jsonResponse = response.data;

        setPromotionsContent([...cmsPromotions, ...jsonResponse]);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchPromotions();
  }, []);

  const slides =
    !_.isEmpty(promotionsContent) &&
    promotionsContent.map((content) => (
      <img
        src={content.image || content.imageLink}
        // height="500px"
        alt="promo"
        className="promotion-image"
      />
    ));

  const content =
    !_.isEmpty(promotionsContent) &&
    promotionsContent.map((content, index) => (
      <div className="text-start">
        <div>
          <h1>{typeof content.shortTitle === "string" ? parse(content.shortTitle) : content.shortTitle}</h1>
        </div>
        <div className="my-4 short-desc">
          <span>{typeof content.shortDescription === "string" ? parse(content.shortDescription) : content.shortDescription}</span>
        </div>
        {/* legacy content */}
        {content.period && (
          <div className="my-4 short-desc">
            Campaign period: <span className="fw-bold">{content.period}</span>
          </div>
        )}
        {/* CMS content */}
        {content.startDate && (
          <div className="my-4 short-desc">
            Campaign period: <span className="fw-bold">{moment(content.startDate).format("DD MMM YYYY")} - {moment(content.endDate).format("DD MMM YYYY")}</span>
          </div>
        )}
        <div className="my-4">
          <PrimaryButton
            text="Learn More"
            className="link-button"
            onClick={() => {
              if (content.href) {
                window.location.href = content.href;
                return;
              }
              if (content.isExternalLink) {
                setExternalLink(content?.externalLink)
                setIsAlert(true);
                return;
              }else{
                if (content.isRizeCampaign) {
                  navigate(`/rize/promotions#${content.slug}`);
                  return;
                }
                navigate(`/personal/promotions/${content.slug}`);
              }}
            }
          />
        </div>
      </div>
    ));

  return (
    <section className="section promotions">
      <Modal
        show={isAlert}
        onHide={() => setIsAlert(false)}
        centered
        size="lg"
        className="alert-modal"
      >
        <Modal.Body>
          <h3>
            <b>You are now leaving alrajhi bank Malaysia website</b>
          </h3>
          <p>
            You are now leaving alrajhi bank Malaysia's (“the Bank”) website. If
            you decide to access any third party websites linked to the Bank’s
            website, you do this entirely at your own risk. The Bank is not
            responsible for nor endorses or shall have any liability arising
            from such sites, products or services offered therein.
          </p>
        </Modal.Body>
        <Modal.Footer
          style={{ border: "none" }}
          className="d-flex justify-content-center flex-nowrap"
        >
          <NormalButton
            text="Close"
            onClick={() => {
              setIsAlert(false);
            }}
            style={{ width: "50%" }}
          />
          <PrimaryButton
            text="Continue"
            onClick={() => {
              window.open(externalLink, "_blank");
              setIsAlert(false);
            }}
            style={{ width: "50%" }}
            id="visit-now"
          />
        </Modal.Footer>
      </Modal>
      <div className="container py-5">
        <Container fluid>
          <Row className="g-5">
            <Col md="5" data-aos="fade-right">
              <Carousel
                autoPlay
                infiniteLoop
                showArrows={false}
                showStatus={false}
                showIndicators={false}
                swipeable
                showThumbs={false}
                stopOnHover={false}
                selectedItem={currentSlide}
                onChange={(index) => setSlide(index)}
              >
                {slides}
              </Carousel>
            </Col>
            <Col md="7" className="align-self-center">
              <div data-aos="fade-left">
                <div className="d-inline-flex justify-content-between pb-3">
                  {promotionsContent.map((_, index) => (
                    <div
                      key={index}
                      onClick={() => setSlide(index)}
                      className={` rounded-circle p-1 mx-1 cursor-pointer ${
                        index === currentSlide
                          ? `primary-background`
                          : `bg-white`
                      }`}
                    />
                  ))}
                </div>
                <Carousel
                  autoPlay
                  infiniteLoop
                  showArrows={false}
                  showStatus={false}
                  showIndicators={false}
                  showThumbs={false}
                  swipeable
                  stopOnHover={false}
                  selectedItem={currentSlide}
                  onChange={(index) => setSlide(index)}
                >
                  {content}
                </Carousel>
              </div>
              <img
                src={line_228}
                alt="line_228"
                className="position-absolute end-0"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default Promotions;
